var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"tw-text-center"},[_c('div',{staticClass:"tw-py-2"},[_c('stepper',{attrs:{"steps":_vm.PROCESS_MODEL_STEPS,"current-step":_vm.currentStep}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64563306","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/evaluation-360/components/process/process-model-stepper.vue
// module id = 1712
// module chunks = 1 2 3